import styled from 'styled-components';
import { Button } from 'ui/button';
import { borderRadius, caption, colors, fontWeights, spacing } from 'ui/theme';

export const StyledListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
  &.multiList {
    background-color: ${colors.backgroundSecondary};
    border-radius: ${borderRadius.md};
    padding: ${spacing.base};
  }
`;

export const StyledInputLabelOptional = styled.span`
  color: ${colors.textSecondary};
  font-weight: ${fontWeights.regular};
`;

export const StyledInputError = styled.div`
  ${caption}
  color: ${colors.textDestructive};
`;

export const StyledSplitButton = styled(Button)`
  align-self: flex-start;
  flex: 0 0 auto;
`;
